/**
 * Fetches the rest of the product gallery once the page has loaded, or as soon
 * as the gallery is touched, whichever comes first.
 *
 * snippets/product-media-gallery-content.liquid keeps every slide after the
 * second lazy, so they no longer share the line with the photo on screen (the
 * LCP). Lazy alone made each later photo arrive 0.4-0.5 s after swiping to it
 * on a phone network; this brings them in while nobody is waiting on anything.
 * Horizon does the same with the mega menu photos (header-menu.js, #preloadImages).
 */

/** @param {Element} gallery */
const warm = (gallery) => {
  for (const image of gallery.querySelectorAll('slideshow-slide img[loading="lazy"]')) {
    if (image instanceof HTMLImageElement) image.loading = 'eager';
  }
};

const galleries = document.querySelectorAll('media-gallery');

// Not once: a variant change morphs the slides back to lazy, and the next
// touch should warm them again. Cheap when nothing is left to warm. No scroll
// listener: the slideshow can scroll itself while it sets up, which would
// warm everything during the load this file exists to keep clear.
for (const gallery of galleries) {
  const onTouch = () => warm(gallery);
  gallery.addEventListener('pointerdown', onTouch, { passive: true });
  gallery.addEventListener('focusin', onTouch);
}

const warmAll = () => galleries.forEach(warm);
const warmWhenIdle = () => {
  if ('requestIdleCallback' in window) requestIdleCallback(warmAll, { timeout: 2000 });
  else setTimeout(warmAll, 200);
};

if (document.readyState === 'complete') warmWhenIdle();
else window.addEventListener('load', warmWhenIdle, { once: true });
